export const CAMPAIGN_TYPES = {
  ONGOING: 'ongoing',
  ONE_OFF: 'one_off',
  ONE_OFF_WHATSAPP: 'one_off_whatsapp',
};
